import * as _ from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { Table, TableModule  } from "primeng/table";
import { Subscription } from 'rxjs';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { SharedHttpClientService } from '../../../Shared/Services/shared-http-client.service';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { UserService } from '../../../Shared/Services/user.service';
import {default as DataGridColumnsJSON} from './CAIS-Recon-Grid-Columns.json';
import { DatePipe, LowerCasePipe, NgClass, CommonModule } from "@angular/common";
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { ButtonModule } from 'primeng/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-cais-recon',
    imports: [FilterPanelComponent, ButtonModule, MatProgressSpinner, ToastModule, CommonModule, TableModule, NgClass, LowerCasePipe],
    templateUrl: './cais-recon.component.html',
    styleUrls: ['./cais-recon.component.scss']
})
export class CAISReconComponent implements OnInit, OnDestroy {

  @ViewChild(('dt')) dt!: Table;
  msgs!: any[];
  tbldatamsg = "L o a d i n g . . . . .";
  reportDate: any;
  LastExecutionCAISDate!: any[];
  DefaultFilterArray: any = [];

  selectedTabIndex: number = 1;
  CAISSummaryTab: boolean = true;
  CAISSubmissionTab: boolean = false;

  isCAISClientDataSummaryLoadingResults = true;
  isCAISFileProcessingSumaryLoadingResults = true;
  isCAISExceptionCodeDetailLoadingResults = true;
  isCAISGenerationSubmissionSummaryLoadingResults = true;
  isCaisSubmissionDataLoadingResults = true;
  isCaisSubmissionDetailsLoadingResults = true;

  CAISClientDataSummaryGridColumns = DataGridColumnsJSON["CaisClientDataSummaryCols"];
  CAISFileProcessingSummaryGridColumns = DataGridColumnsJSON["CaisFileProcessingSummaryCols"];
  CAISExceptionCodeDetailSummaryGridColumns = DataGridColumnsJSON["CaisDetailByExceptionCodeCols"];
  CAISGenerationSubmissionDataSummaryGridColumns = DataGridColumnsJSON["caisGenerationSubmissionSummaryCols"];
  CAISSubmissionDataSummaryGridColumns = DataGridColumnsJSON["CaisSubmissionDataSummaryCols"];
  CAISSubmissionDetailSummaryGridColumns = DataGridColumnsJSON["CaisSubmissionDetailSummaryCols"];

  CaisClientDataSummaryCols: any = [];
  CaisFileProcessingSummaryCols: any = [];
  CaisDetailByExceptionCodeCols: any = [];
  caisGenerationSubmissionSummaryCols: any = [];
  CaisSubmissionDataSummaryCols: any = [];
  CaisSubmissionDetailSummaryCols: any = [];

  caisClientDataSet: any[] = [];
  caisProcessedFileDataSet: any[] = [];
  caisExceptionCodeDetailDataSet: any[] = [];
  caisGenerationSubmissionDataSet: any[] = [];
  caisSubmissionDataSet: any[] = [];
  caisSubmissionDetailDataSet: any[] = [];

  private subscription!: Subscription;

  constructor(
    private UserService: UserService,
    private gridService: GridService,
    private emitterService: EmitterService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    public constantService: ConstantService,
    private userService: UserService,
    private datePipe: DatePipe) {
      this.reportDate = this.userService.getyyyyMMddDateFormate(this.UserService.CAISLastReportDate);
  }

  ngOnInit(): void {
    /*** Get Last CAT Execution date*/
    let todate: any;
    todate = this.UserService.CAISLastReportDate;
    this.LastExecutionCAISDate = [];
    if (todate != "" || todate != undefined || todate != null) {
      this.LastExecutionCAISDate[0] = (todate);
      this.LastExecutionCAISDate[1] = (todate);
      this.defaultFilter();
    }
    this.getColumns();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe({
      next: (value:any) => {
      if (value) {
        this.getData();
      }
    }});
  }

  getColumns() {
    // CAIS Processing Columns
    let caisClientDataSummaryGridcolumn: any = this.CAISClientDataSummaryGridColumns;
    this.CaisClientDataSummaryCols = this.gridService.getGridColumns(caisClientDataSummaryGridcolumn);

    let caisFileProcessingSummaryGridcolumn: any = this.CAISFileProcessingSummaryGridColumns;
    this.CaisFileProcessingSummaryCols = this.gridService.getGridColumns(caisFileProcessingSummaryGridcolumn);

    let CaisExceptionCodeDetailSummaryGridcolumn: any = this.CAISExceptionCodeDetailSummaryGridColumns;
    this.CaisDetailByExceptionCodeCols = this.gridService.getGridColumns(CaisExceptionCodeDetailSummaryGridcolumn);
  
    // CAIS Submission Summary Columns
    let CaisGenerationSubmissionDataSummaryGridColumn: any = this.CAISGenerationSubmissionDataSummaryGridColumns;
    this.caisGenerationSubmissionSummaryCols = this.gridService.getGridColumns(CaisGenerationSubmissionDataSummaryGridColumn);

    let CaisSubmissionDataSummaryGridColumn: any = this.CAISSubmissionDataSummaryGridColumns;
    this.CaisSubmissionDataSummaryCols = this.gridService.getGridColumns(CaisSubmissionDataSummaryGridColumn);

    let CaisSubmissionDetailSummaryGridColumn: any = this.CAISSubmissionDetailSummaryGridColumns;
    this.CaisSubmissionDetailSummaryCols = this.gridService.getGridColumns(CaisSubmissionDetailSummaryGridColumn);
  }

  getOptedTab(tabIndex: number, tabText: string) {
    this.CAISSummaryTab =  (tabText.includes('CAIS Processing') ? true : false);
    this.CAISSubmissionTab = (tabText.includes('CAIS Submission') ? true : false);
    this.selectedTabIndex = tabIndex;
  }

  FilterApplyFilterEvent(event: any) {
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.getData();
  }

  defaultFilter() {
    if (this.reportDate) {
      this.LastExecutionCAISDate = [];
      this.LastExecutionCAISDate.push(this.UserService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.reportDate/* '2022-09-23' *//* '2023-03-02' *//* '2022-12-08' */)));
      this.LastExecutionCAISDate.push(this.UserService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.reportDate/* '2022-09-23' *//* '2023-03-02' *//* '2022-12-08' */)));
    }

    this.DefaultFilterArray = [
      {
        "isdefault": "true", "label": "Date", "columnname": "reportDate", "filterby": "IS", "values": this.LastExecutionCAISDate, "time": "", "datatype": "DateRange", "disabled": "true", "dropdown": "", "dropdownvalue": ""
      }
    ];
    this.getData();
  }

  getData() {
    this.tbldatamsg = "L o a d i n g . . . . .";

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));

    this.getCAISSummaryData(filterData);
    this.getCAISSubmissionData(filterData);
  }

  getCAISSummaryData(filterData?: any) {
    this.isCAISClientDataSummaryLoadingResults = true;
    this.isCAISFileProcessingSumaryLoadingResults = true;
    this.isCAISExceptionCodeDetailLoadingResults = true;
    this.caisClientDataSet = [];
    this.caisProcessedFileDataSet = [];
    this.caisExceptionCodeDetailDataSet = [];
    this.reportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    let payload = {
      mpid: this.userService.getActiveMPID(),
      reportType: "1",
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate)
    }

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAIS_RECON
      ), payload
    ).subscribe({
      next: (element:any) => {
        let dataset: any = element;
        if (dataset.length == 0) {
          this.tbldatamsg = "No data found";
        } else {
          /* Prepare Client Data Summary */
          if(dataset.CAISClientSummaryData.Data && dataset.CAISClientSummaryData.Data.length > 0) {
            this.prepareClientSummaryData(dataset.CAISClientSummaryData.Data);
          }
          /* File Processing Summary */
          if(dataset.CAISFileProcessingSummaryData.Data && dataset.CAISFileProcessingSummaryData.Data.length > 0) {
            this.caisProcessedFileDataSet = dataset.CAISFileProcessingSummaryData.Data;
          }
          /* Exception Summary Detail */
          if(dataset.CAISExceptionCodeDetailSummaryData.Data && dataset.CAISExceptionCodeDetailSummaryData.Data.length > 0) {
            this.prepareExceptionCodeSummaryData(dataset.CAISExceptionCodeDetailSummaryData.Data);
          }
        }
        this.isCAISClientDataSummaryLoadingResults = false;
        this.isCAISFileProcessingSumaryLoadingResults = false;
        this.isCAISExceptionCodeDetailLoadingResults = false;
      }, error: (err: HttpErrorResponse) => {
        this.isCAISClientDataSummaryLoadingResults = false;
        this.isCAISFileProcessingSumaryLoadingResults = false;
        this.isCAISExceptionCodeDetailLoadingResults = false;
    }});
  }

  getCAISSubmissionData(filterData?: any) {
    this.isCAISGenerationSubmissionSummaryLoadingResults = true;
    this.isCaisSubmissionDataLoadingResults = true;
    this.isCaisSubmissionDetailsLoadingResults = true;
    this.caisGenerationSubmissionDataSet = [];
    this.caisSubmissionDataSet = [];
    this.caisSubmissionDetailDataSet = [];
    this.reportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    let payload = {
      mpid: this.userService.getActiveMPID(),
      reportType: "2",
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate)
    }

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAIS_RECON
      ), payload
    ).subscribe({
      next: (element:any) => {
        let dataset: any = element;
        if (dataset == 0) {
          this.tbldatamsg = "No data found";
        } else {
          /* Prepare Generation Summary */
          if(dataset.CAISGenerationData.Data && dataset.CAISGenerationData.Data.length > 0) {
            this.prepareGenerationSummaryData(dataset.CAISGenerationData.Data);
          }
          /* Prepare Feedback Summary */
          if(dataset.CAISFeedbackData.Data && dataset.CAISFeedbackData.Data.length > 0) {
            this.prepareFeedbackSummaryData(dataset.CAISFeedbackData.Data);
          }
        }
        this.isCAISGenerationSubmissionSummaryLoadingResults = false;
        this.isCaisSubmissionDataLoadingResults = false;
        this.isCaisSubmissionDetailsLoadingResults = false;
      }, error: (err: HttpErrorResponse) => {
        this.isCAISGenerationSubmissionSummaryLoadingResults = false;
        this.isCaisSubmissionDataLoadingResults = false;
        this.isCaisSubmissionDetailsLoadingResults = false;
    }});
  }

  prepareClientSummaryData(clientDataSummaryDetail: any[]) {
    this.caisClientDataSet = [];
    if(clientDataSummaryDetail.length > 0) {
      this.caisClientDataSet.push({"fileType": "FDID", "processedcount": clientDataSummaryDetail[0]["FDID_Processed"], "acceptedcount": clientDataSummaryDetail[0]["FDID_Accepted"], "rejectedcount": clientDataSummaryDetail[0]["FDID_Rejected"]});
      this.caisClientDataSet.push({"fileType": "Customer", "processedcount": (clientDataSummaryDetail[0]["Entity_Processed"]+clientDataSummaryDetail[0]["Person_Processed"]), "acceptedcount": (clientDataSummaryDetail[0]["Entity_Accepted"]+clientDataSummaryDetail[0]["Person_Accepted"]), "rejectedcount": (clientDataSummaryDetail[0]["Entity_Rejected"]+clientDataSummaryDetail[0]["Person_Rejected"])});
      this.caisClientDataSet.push({"fileType": "TID", "processedcount": clientDataSummaryDetail[0]["TID_Processed"], "acceptedcount": clientDataSummaryDetail[0]["TID_Accepted"], "rejectedcount": clientDataSummaryDetail[0]["TID_Rejected"]});
    }
  }

  prepareExceptionCodeSummaryData(exceptionCodeDetail: any[]) {
    this.caisExceptionCodeDetailDataSet = [];
    if(exceptionCodeDetail.length > 0) {
      this.caisExceptionCodeDetailDataSet = exceptionCodeDetail;
      let FDIDTotalCount = 0, personTotalCount = 0, entityTotalCount = 0, supplementTotalCount = 0, LTIDTotalCount = 0, TIDTotalCount = 0;
      for(let i=0; i<exceptionCodeDetail.length; i++) {
        FDIDTotalCount += this.caisExceptionCodeDetailDataSet[i]["fdidCount"];
        personTotalCount += this.caisExceptionCodeDetailDataSet[i]["personCount"];
        entityTotalCount += this.caisExceptionCodeDetailDataSet[i]["entityCount"];
        supplementTotalCount += this.caisExceptionCodeDetailDataSet[i]["supplementCount"];
        LTIDTotalCount += this.caisExceptionCodeDetailDataSet[i]["ltidCount"];
        TIDTotalCount += this.caisExceptionCodeDetailDataSet[i]["tidCount"];
        this.caisExceptionCodeDetailDataSet[i]["totalCount"] = (this.caisExceptionCodeDetailDataSet[i]["fdidCount"] + this.caisExceptionCodeDetailDataSet[i]["personCount"] + this.caisExceptionCodeDetailDataSet[i]["entityCount"] + this.caisExceptionCodeDetailDataSet[i]["supplementCount"] + this.caisExceptionCodeDetailDataSet[i]["ltidCount"] + this.caisExceptionCodeDetailDataSet[i]["tidCount"]);
      }
      this.caisExceptionCodeDetailDataSet.push({"failureCode": "Total", "failureDescription": "", "fdidCount": FDIDTotalCount, "personCount": personTotalCount, "entityCount": entityTotalCount, "supplementCount": supplementTotalCount, "ltidCount": LTIDTotalCount, "tidCount": TIDTotalCount, "totalCount": (FDIDTotalCount + personTotalCount + entityTotalCount + supplementTotalCount + LTIDTotalCount + TIDTotalCount)});
    }
  }

  prepareGenerationSummaryData(generationSummaryDetail: any[]) {
    this.caisGenerationSubmissionDataSet = [];
    if(generationSummaryDetail.length) {
      for(let i=0; i<generationSummaryDetail.length; i++) {
        generationSummaryDetail[i]["fileModified"] = this.datePipe.transform(new Date(generationSummaryDetail[i]["fileModified"]), "yyyy-MM-dd HH:mm:ss");
      }
    }
    this.caisGenerationSubmissionDataSet = generationSummaryDetail;
  }

  prepareFeedbackSummaryData(feedbackSummaryDetail: any[]) {
    /* Submission Data */
    this.caisSubmissionDataSet = [];
    if(feedbackSummaryDetail.length > 0) {
      let CAISFileIndex = feedbackSummaryDetail.findIndex((feedbackObj: { fileKind: string; }) => feedbackObj.fileKind==='CAIS');
      let TIDSFileIndex = feedbackSummaryDetail.findIndex((feedbackObj: { fileKind: string; }) => feedbackObj.fileKind==='TIDS');

      let CAISFDIDSubmittedCount = 0, CAISFDIDAcceptedCount = 0, CAISFDIDRejetedCount = 0, CAISNaturalPersonSubmittedCount = 0, CAISNaturalPersonAcceptedCount = 0, CAISNaturalPersonRejetedCount = 0,
          CAISLegalEntitySubmittedCount = 0, CAISLegalEntityAcceptedCount = 0, CAISLegalEntityRejetedCount = 0, CAISTIDSubmittedCount = 0, CAISTIDAcceptedCount = 0, CAISTIDRejetedCount = 0;

      if(feedbackSummaryDetail[CAISFileIndex] && feedbackSummaryDetail[CAISFileIndex]["receivedFDIDRecordCount"]) {
        CAISFDIDSubmittedCount = feedbackSummaryDetail[CAISFileIndex]["receivedFDIDRecordCount"];
      }

      if(feedbackSummaryDetail[CAISFileIndex] && feedbackSummaryDetail[CAISFileIndex]["successfulFDIDRecordCount"]) {
        CAISFDIDAcceptedCount = feedbackSummaryDetail[CAISFileIndex]["successfulFDIDRecordCount"];
      }

      if(feedbackSummaryDetail[CAISFileIndex]) {
        CAISFDIDRejetedCount = (feedbackSummaryDetail[CAISFileIndex]["receivedFDIDRecordCount"] - feedbackSummaryDetail[CAISFileIndex]["successfulFDIDRecordCount"]);
      }

      if(feedbackSummaryDetail[CAISFileIndex] && feedbackSummaryDetail[CAISFileIndex]["receivedNaturalRecordCount"]) {
        CAISNaturalPersonSubmittedCount = feedbackSummaryDetail[CAISFileIndex]["receivedNaturalRecordCount"];
      }

      if(feedbackSummaryDetail[CAISFileIndex] && feedbackSummaryDetail[CAISFileIndex]["successfulNaturalRecordCount"]) {
        CAISNaturalPersonAcceptedCount = feedbackSummaryDetail[CAISFileIndex]["successfulNaturalRecordCount"];
      }

      if(feedbackSummaryDetail[CAISFileIndex]) {
        CAISNaturalPersonRejetedCount = (feedbackSummaryDetail[CAISFileIndex]["receivedNaturalRecordCount"] - feedbackSummaryDetail[CAISFileIndex]["successfulNaturalRecordCount"]);
      }

      if(feedbackSummaryDetail[CAISFileIndex] && feedbackSummaryDetail[CAISFileIndex]["receivedLegalEntityRecordCount"]) {
        CAISLegalEntitySubmittedCount = feedbackSummaryDetail[CAISFileIndex]["receivedLegalEntityRecordCount"];
      }

      if(feedbackSummaryDetail[CAISFileIndex] && feedbackSummaryDetail[CAISFileIndex]["successfulLegalEntityRecordCount"]) {
        CAISLegalEntityAcceptedCount = feedbackSummaryDetail[CAISFileIndex]["successfulLegalEntityRecordCount"];
      }

      if(feedbackSummaryDetail[CAISFileIndex]) {
        CAISLegalEntityRejetedCount = (feedbackSummaryDetail[CAISFileIndex]["receivedLegalEntityRecordCount"] - feedbackSummaryDetail[CAISFileIndex]["successfulLegalEntityRecordCount"]);
      }

      if(feedbackSummaryDetail[TIDSFileIndex] && feedbackSummaryDetail[TIDSFileIndex]["receivedTIDsCount"]) {
        CAISTIDSubmittedCount = feedbackSummaryDetail[TIDSFileIndex]["receivedTIDsCount"];
      }

      if(feedbackSummaryDetail[TIDSFileIndex] && feedbackSummaryDetail[TIDSFileIndex]["successfulTIDsCount"]) {
        CAISTIDAcceptedCount = feedbackSummaryDetail[TIDSFileIndex]["successfulTIDsCount"];
      }

      if(feedbackSummaryDetail[TIDSFileIndex]) {
        CAISTIDRejetedCount = (feedbackSummaryDetail[TIDSFileIndex]["receivedTIDsCount"] - feedbackSummaryDetail[TIDSFileIndex]["successfulTIDsCount"]);
      }

      this.caisSubmissionDataSet.push({"fileType": "FDID", "submittedcount": CAISFDIDSubmittedCount, "acceptedcount": CAISFDIDAcceptedCount, "rejectedcount": CAISFDIDRejetedCount});
      this.caisSubmissionDataSet.push({"fileType": "Natural Person", "submittedcount": CAISNaturalPersonSubmittedCount, "acceptedcount": CAISNaturalPersonAcceptedCount, "rejectedcount": CAISNaturalPersonRejetedCount});
      this.caisSubmissionDataSet.push({"fileType": "Legal Entity", "submittedcount": CAISLegalEntitySubmittedCount, "acceptedcount": CAISLegalEntityAcceptedCount, "rejectedcount": CAISLegalEntityRejetedCount});
      this.caisSubmissionDataSet.push({"fileType": "TID", "submittedcount": CAISTIDSubmittedCount, "acceptedcount": CAISTIDAcceptedCount, "rejectedcount": CAISTIDRejetedCount});
    }

    /* Submission Summary Details */
    this.caisSubmissionDetailDataSet = [];
    if(feedbackSummaryDetail.length) {
      for(let i=0; i<feedbackSummaryDetail.length; i++) {
        feedbackSummaryDetail[i]["receiptTimestamp"] = this.datePipe.transform(new Date(feedbackSummaryDetail[i]["receiptTimestamp"]), "yyyy-MM-dd HH:mm:ss");
        feedbackSummaryDetail[i]["fileStatus"] = feedbackSummaryDetail[i]["fileKind"]==="CAIS" ? "Received" : (feedbackSummaryDetail[i]["fileKind"]==="TIDS" ? "Successful": "");
      }
    }
    this.caisSubmissionDetailDataSet = feedbackSummaryDetail;
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

}